import PropTypes from 'prop-types';

import style from './style.module.css';

const classNames = {
  PRIMARY: style.primary,
  SECONDARY: style.secondary,
};

const Spinner = ({ type = 'PRIMARY' }) => (
  <div className={`${style.spinner} ${classNames[type]}`}>
    <div />
    <div />
    <div />
    <div />
  </div>
);

Spinner.propTypes = {
  type: PropTypes.oneOf(['PRIMARY', 'SECONDARY']),
};

export default Spinner;
